import { Typography } from '@material-ui/core';
import style from '../../../commonStyle';

const HealthCareSuggestion = () => {
  const classes = style();
  return (
    <div className={classes.suggestionContainer}>
      <Typography className={classes.title} component="h1">
        🧭 TROIS VOIES D’ORIENTATION PRIVILÉGIÉES :
      </Typography>
      <div className={classes.suggestionContent}>
        <Typography className={classes.suggestionSubtitle} component="p">
          Voici trois voies que tu pourrais emprunter pour atteindre tes objectifs en fonction de
          tes résultats scolaires :
        </Typography>
        <ul className={classes.suggestionList}>
          <li>
            <Typography className={classes.suggestionListItem} component="p">
              Pour les élèves avec d&apos;excellents résultats (moyenne ≥15) : licence universitaire
              PASS.
            </Typography>
          </li>
          <li>
            <Typography className={classes.suggestionListItem} component="p">
              Pour les élèves avec de bons résultats (moyenne ≥12) : licence universitaire avec
              option santé.
            </Typography>
          </li>
          <li>
            <Typography className={classes.suggestionListItem} component="p">
              Pour les élèves avec des résultats moyens (moyenne ≥10) : licence universitaire de
              psychologie, BTS diététique, etc.
            </Typography>
          </li>
        </ul>
        <Typography className={classes.suggestionSubtitle} component="p">
          Les études de santé nécessitent un solide niveau et une grande appétence pour les matières
          scientifiques.
        </Typography>
        <Typography className={classes.suggestionQuote} component="p">
          « Que ton aliment soit ta seule médecine ! »
        </Typography>
      </div>
      <Typography className={classes.suggestionQuoteAuthor} component="p">
        Hippocrate
      </Typography>
    </div>
  );
};

export default HealthCareSuggestion;
